import { AdditionalServicesProductResponse, AdditionalServicesProductResponseItem } from '@/types/service-response'

export class AdditionalServicesProduct {
  private constructor (
    readonly id: number,
    readonly name: string,
    readonly number: number,
    readonly price: number,
    readonly currency: string,
    readonly unit: string,
    readonly LGID: number
  ) {}

  static createListFromResponse (responseData: AdditionalServicesProductResponse): Array<AdditionalServicesProduct> {
    return responseData.map((item: AdditionalServicesProductResponseItem) => {

      return new AdditionalServicesProduct(
        item.ID,
        item.Name,
        item.Nummer,
        item.Preis,
        item.Waehrung,
        item.Einheit,
        item.LGID
      )
    })
  }
}
